import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BadgeModule} from 'primeng/badge';

@Component({
  selector: 'app-color-picker',
  imports: [BadgeModule],
  templateUrl: './color-picker.component.html',
  styleUrl: './color-picker.component.scss',
})
export class ColorPickerComponent implements AfterViewInit{
  ngAfterViewInit(): void {
    this.selectColor(this.selectedColor);
  }

  @Output() colorChange = new EventEmitter<string>();

  colors: string[] = [
    '#FF0000',
    '#FF4D00',
    '#FF7B43',
    '#FFB443',
    '#FFF129',
    '#B2FF00',
    '#00BC23',
    '#00BC9A',
    '#FFFFFF',
    '#00E1FA',
    '#00BBCF',
    '#007DEA',
    '#000CEA',
    '#6100EA',
    '#AB00EA',
    '#FB68D7',
    '#EA00AF',
    '#000000'
  ];

  selectedColor: string = "#FF0000";


  protected selectColor(color: string) {
    this.selectedColor = color;
    this.colorChange.emit(color);
  }
}
